import CategoryInfo from 'components/CarSettings/Category/Creation/CategoryInfo'
import Summary from 'components/CarSettings/Category/Creation/Summary'
import { StepperModel } from 'components/General/Stepper'

import {
  CategoryCreationAction,
  CategoryCreationModel,
} from 'models/categoryCreation'
import { StepperTextType } from 'models/text/General'

export type CategoryCreationProps = {
  handleBack: () => void
  handleContinue: () => void
  handleSubmit: () => void
  submitLoading: boolean
  categoryData: CategoryCreationModel
  updateCategoryData: (action: CategoryCreationAction) => void
}

export const INITIAL_CATEGORY_CREATION_STEPS: Array<
  React.FC<CategoryCreationProps>
> = [CategoryInfo, Summary]

export const createCategoryStepperItems = (
  text: StepperTextType
): StepperModel[] => {
  const stepperItems: StepperModel[] = [
    {
      label: text.firstStep,
    },
    { label: text.secondStep },
  ]

  return stepperItems
}
